export class PricingRule {}

export class Condition {
  constructor() {
    this.online = false;
  }
}

export class Action {}
